import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useStore } from 'react-redux';
import { useHistory } from "react-router-dom";
import useMedia from 'use-media';
import { useRtoaster } from '../../../hooks/useRtoaster';
import { apiKeyCheck, versionGetApi } from '../../../const';
import image_complete from '../../../resources/icons/complete.svg';
import image_base from '../../../resources/image/HakoneGardenTerrace.jpg';
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import './../../../resources_membership_hotel/css/hotel/membership_reserve_comp.css';
import { MembershipFooterContainer } from './../common/membershipFooterContainer';


const MembershipCompleteAccompanyContainer = (props) => {
    const { state } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    const login = store.getState().login;
    const loginType = login.loginType;

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
            common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        window.scroll({ top: 0, behavior: 'smooth' })
        common.doPost(versionGetApi, {}, afterVerCheck);
    }, []);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // ホテル予約TOPへ戻るボタン押下時処理
    const onClickDecision = () => {
        store.dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: {}} })
        if (loginType === "MEMBER") {
            history.push("/reserve/hotel/search");
        } else if (loginType === "CRAWL") {
            history.push("/reserve/hotel/crawlSearch");
        }
    }

    return (
        <div style={isWideTablet ? styles.topCancel : styles.top}>
            <div className={isWideTablet ? "membership_reserve_base2" : "membership_reserve_base"}>
                <div style={styles.complete}></div>
                <p className="membership_reserve_title">ご予約の変更を承りました</p>
                <p className={isWideTablet ? "membership_reserve_text2" : "membership_reserve_text"}>
                    ご利用いただき誠にありがとうございます。
                    <br />予約完了メールをお送りいたしましたので、{isWideTablet ? <br /> : null}内容をご確認ください。
                </p>
                <div className='membership_btn_area'>
                    <Button buttonText="ホテル予約TOPへ戻る" className="membership_top_btn" onClick={onClickDecision} />
                </div>
            </div>
            <div><MembershipFooterContainer className={"reservationResultFooterBase"} /></div>
        </div >
    )
}

const styles = {
    topMobile: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (12.3rem + 75px))",
    },
    top: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (9.8rem + 100px))",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (7.1rem + 100px))",
        height: "100%",
    },
    complete: {
        width: "50px",
        height: "50px",
        backgroundImage: `url(${image_complete})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        margin: "0px auto 10px",
    },
    none: {
        display: "none"
    },
}

export default MembershipCompleteAccompanyContainer;
